var map = {
	"./img/loginbg2.png": "./application/report/assets/img/loginbg2.png",
	"./img/logo2.png": "./application/report/assets/img/logo2.png",
	"./img/summary_icon/2.png": "./application/report/assets/img/summary_icon/2.png",
	"./img/未标题2.png": "./application/report/assets/img/未标题2.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./application/report/assets sync recursive ^.*2\\.png$";